import { axiosInstance } from '../request';
export const getIntegrations = async () => {
    const response = await axiosInstance.get('/api/v1/integrations');
    return response.data;
};
export const connectByCredentials = async (data) => {
    const body = data.session_token
        ? {
            username: data.username,
            password: data.password,
            session_token: data.session_token,
            totp_code: data.totp_code
        }
        : {
            username: data.username,
            password: data.password,
            hv_token: data.hv_token,
            hv_token_type: data.hv_token_type
        };
    const response = await axiosInstance.post(`/api/v1/integrations/${data.oauthType}/connect`, body);
    return response.data;
};
export const setDefaultConnectedServices = async (data) => {
    const response = await axiosInstance.put(`/api/v1/integrations/${data.oauthType}/primary?platform_unique_id=${data.platform_unique_id}`);
    return response.data;
};
export const disconnect = async (data) => {
    const response = await axiosInstance.delete(`/api/v1/integrations/${data.oauthType}/disconnect?platform_unique_id=${data.platform_unique_id}`);
    return response.data;
};
export const authStart = async (oauthType) => {
    const response = await axiosInstance.get(`/api/v1/oauth/${oauthType}/start`);
    return response.data;
};
export const authCallback = async (data) => {
    const response = await axiosInstance.get(`/api/v1/oauth/${data.oauthType}/callback?${data.params}`);
    return response.data;
};
//# sourceMappingURL=oauth.api.js.map